import { createForOfIteratorHelperLoose as _createForOfIteratorHelperLoose } from '../_virtual/_rollupPluginBabelHelpers.js';

/**
 * Filter an object to keep or remove certain keys
 * @param input Object to filter
 * @param keys Keys that can be kept or removed
 * @param invert Whether the keys are kept (false) or remove (true)
 */
function filterObject(input, keys, invert) {
  if (invert === void 0) {
    invert = false;
  }

  return Object.keys(input).filter(function (key) {
    return invert ? !keys.includes(key) : keys.includes(key);
  }).reduce(function (obj, key) {
    var _Object$assign;

    return Object.assign(obj, (_Object$assign = {}, _Object$assign[key] = input[key], _Object$assign));
  }, {});
}
function omit(object, keys) {
  var result = {};

  for (var key in object) {
    // eslint-disable-next-line no-continue
    if (keys.includes(key)) continue;
    result[key] = object[key];
  }

  return result;
}
function pick(object, keys) {
  var result = {};

  for (var _iterator = _createForOfIteratorHelperLoose(keys), _step; !(_step = _iterator()).done;) {
    var key = _step.value;

    if (key in object) {
      result[key] = object[key];
    }
  }

  return result;
}

export { filterObject, omit, pick };
//# sourceMappingURL=object.esm.js.map
